<script>
  import Search from '@/assets/search.svg';
  import FinancierInput from '@/components/Financier/Input';

  export default {
    components: {
      FinancierInput,
    },

    data: () => ({
      filters: {
        couple: 0,
        search: '',
        type: -1,
        status: -1,
      },
    }),

    computed: {
      selected () {
        return (this.couple.options.find((_, index) => index === this.filters.couple) || {}).label;
      },

      search () {
        return {
          type: 'text',
          label: 'Pesquisar',
          icon: Search,
        };
      },

      couple () {
        return {
          type: 'select',
          label: 'Par',
          options: [
            {
              value: 0,
              label: 'BTC/BRL',
            },
          ],
        };
      },

      status () {
        return {
          type: 'select',
          label: 'Status',
          options: [
          ],
        };
      },

      type () {
        return {
          type: 'select',
          label: 'Tipo',
          options: [
          ],
        };
      },
    },
  };
</script>

<template>
  <main class="financier-order">
    <h1 class="sidebar__title">Ordens</h1>

    <div class="sidebar__header">
      <FinancierInput
        v-bind="search"
        v-model="filters.search"
        />

      <FinancierInput
        v-bind="couple"
        v-model="filters.couple"
        />

      <FinancierInput
        v-bind="status"
        v-model="filters.status"
        />

      <FinancierInput
        v-bind="type"
        v-model="filters.type"
        />
    </div>

    <template v-if="selected">
      <h2 class="financier-order__title" v-text="selected"></h2>

      <table class="financier-order__table">
        <thead class="financier-order__table-header">
          <tr class="financier-order__table-header-row">
            <th class="financier-order__table-header-item" width="6%">Tipo</th>
            <th class="financier-order__table-header-item">Criada em:</th>
            <th class="financier-order__table-header-item">Preço unitário</th>
            <th class="financier-order__table-header-item">Total executado</th>
            <th class="financier-order__table-header-item">Total restante</th>
            <th class="financier-order__table-header-item" width="8%">%</th>
            <th class="financier-order__table-header-item" width="15%">Status</th>
          </tr>
        </thead>

        <tbody class="financier-order__table-body">
          <tr
            :key="index"
            v-for="index in 12"
            class="financier-order__table-body-row"
            >
            <td class="financier-order__table-body-item financier-order__table-body-item--center">
              <span
                class="financier-order__type"
                v-text="index % 3 ? 'C' : 'V'"
                :class="index % 3 ? 'financier-order__type--buy' : 'financier-order__type--sell'"
                >
              </span>
            </td>

            <td class="financier-order__table-body-item">
              02/04/2019
              <span class="financier-order__small">09:34</span>
            </td>

            <td class="financier-order__table-body-item">
              R$ 21.245,34
            </td>

            <td class="financier-order__table-body-item">
              0,35546677
              <span class="financier-order__small">R$ 14.346,56</span>
            </td>

            <td class="financier-order__table-body-item">
              0,35546677
              <span class="financier-order__small">R$ 14.346,56</span>
            </td>

            <td class="financier-order__table-body-item">
              10%
            </td>

            <td class="financier-order__table-body-item financier-order__table-body-item--small">
              Parcialmente executada
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </main>
</template>

<style lang="scss">
  .financier-order {
    &__title {
      color: #FFF;
      line-height: 1;
      font-size: 20px;
      margin-bottom: 24px;
      letter-spacing: .4px;
    }

    &__table {
      width: 100%;
      text-align: left;
      border-spacing: 0;

      &-header-item {
        color: #8e95a9;
        font-weight: 300;
        line-height: 1.25;
        padding: 16px 8px;
        letter-spacing: .32px;
      }

      &-body {
        letter-spacing: .32px;
        color: rgba(#FFF, .8);

        &-row:nth-child(even) {
          background-color: rgba(#14162f, .3);
        }

        &-item {
          padding: 16px 8px;
          vertical-align: top;

          &--center {
            vertical-align: middle;
          }

          &--small {
            font-size: 13px;
            line-height: 1.23;
            letter-spacing: .26px;
          }
        }
      }
    }

    &__type {
      width: 32px;
      height: 32px;
      color: #FFF;
      display: flex;
      border-radius: 50%;
      align-items: center;
      justify-content: center;

      &--buy {
        background-color: #509e02;
      }

      &--sell {
        background-color: #d0021c;
      }
    }

    &__small {
      display: block;
      font-size: 13px;
      margin-top: 8px;
      color: rgba(#b2b8c5, .7);
    }
  }
</style>
